<template>
  <div class="make_managenment">
    <div>
      <el-button type="primary" style="width:120px" @click="addMatchModal">添加赛事</el-button>
    </div>
    <el-table border :data="tableData" style="margin-top:40px" :style="{width:'100%'}">
      <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
      <el-table-column
        v-if="userInfo.project == 2 || userInfo.project == 3"
        align="center"
        label="赛事名称"
        prop="name"
      ></el-table-column>
      <el-table-column align="center" label="组别" width="160">
        <template slot-scope="{row}">
          <span
            v-if="!isOtherBall && userInfo.project !== 4 && userInfo.project !== 2 && userInfo.project !== 3"
          >{{!row.groupId?'':row.groupId == 1?'甲组':row.groupId == 2?'乙组':row.groupId == 3?'丁组':row.groupId == 4?'丙组':'混合组'}}</span>
          <span
            v-else-if="userInfo.project == 2 || userInfo.project == 3"
          >{{formatGroups(row.groupId)}}</span>
          <span v-else>{{formatGroup(row.groupId)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="userInfo.project !== 2 && userInfo.project !== 3"
        align="center"
        label="赛事名称"
        prop="name"
      ></el-table-column>
      <el-table-column align="center" label="报名开始时间" prop="startTime"></el-table-column>
      <el-table-column align="center" label="报名结束时间" prop="endTime"></el-table-column>
      <template v-if="userInfo.project !== 2 && userInfo.project !== 3">
        <el-table-column align="center" label="人数限制" prop="count"></el-table-column>
        <el-table-column align="center" label="性别" prop="gender">
          <template slot-scope="{row}">
            <span>{{formatGender(row.gender)}}</span>
          </template>
        </el-table-column>
      </template>
      <template v-else-if="userInfo.project === 2">
        <el-table-column align="center" label="队伍人数限制" prop="allCountText"></el-table-column>
        <el-table-column align="center" label="团体人数限制" prop="allPoomaseCountText"></el-table-column>
      </template>
      <el-table-column label="操作" align="center">
        <template slot-scope="{row}">
          <el-button type="text" @click="updates(row)" style="color:#199AFF;">修改</el-button>
          <el-button type="text" @click="deletes(row.id)" style="color:#FD6666;margin-left:20px">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:20px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <el-dialog
      custom-class="add_match"
      :lock-scroll="false"
      :append-to-body="true"
      center
      :close-on-click-modal="false"
      :title="title"
      @close="closeModal"
      :visible.sync="centerDialogVisible"
      :width="isOtherBall?'700px':userInfo.project === 4?'750px':'590px'"
    >
      <el-form
        ref="form"
        :model="query"
        :rules="rules"
        :label-width="isOtherBall || userInfo.project === 4 ?'140px':'100px'"
      >
        <el-form-item label="赛事名称" prop="name">
          <el-input style="width:424px" v-model="query.name" placeholder="请输入赛事名称"></el-input>
        </el-form-item>
        <template v-if="isOtherBall || userInfo.project === 4">
          <el-form-item class="group_id" label="参赛组别" prop="groupId">
            <el-checkbox-group v-model="query.groupId">
              <el-checkbox label="1">甲组</el-checkbox>
              <el-checkbox label="2">乙组</el-checkbox>
              <el-checkbox label="3">丙组</el-checkbox>
              <el-checkbox label="4">丁组</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
        <!-- 足球赛事组别 -->
        <template v-else-if="userInfo.project === 7">
          <el-form-item label="参赛组别" prop="groupId">
            <el-select
              :popper-append-to-body="false"
              v-model="query.groupId"
              placeholder="请选择参赛组别"
              @change="selectGroup"
            >
              <el-option
                v-for="(item,index) in registGroup"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
              <el-option value="5" label="混合组"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="参赛组别" prop="groupId">
            <el-select :popper-append-to-body="false" v-model="query.groupId" placeholder="请选择参赛组别">
              <el-option
                v-for="(item,index) in registGroup"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="报名时间" prop="time">
          <el-date-picker
            v-model="query.time"
            style="width:424px"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <template v-if="isOtherBall">
          <el-row>
            <el-col :span="13.5">
              <el-form-item :label="userInfo.project == 9?'每组限报人数':'每队限报人数'" prop="count">
                <el-input
                  style="width:80px"
                  onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                  maxlength="4"
                  v-model="query.count"
                ></el-input>
                <span style="margin-left:6px">人，</span>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form :model="query">
                <el-form-item :label="userInfo.project == 9?'每组单一性别不得超过':'每队单一性别不得超过'">
                  <el-input
                    style="width:80px"
                    onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                    maxlength="4"
                    v-model="query.genderCount"
                  ></el-input>
                  <span style="margin-left:6px">人</span>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9.5">
              <el-form-item :label="userInfo.project == 9?'每组每项限报':'每队每项限报'">
                <el-input
                  style="width:80px"
                  onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                  maxlength="4"
                  v-model="query.memberProjectCount"
                ></el-input>
                <span style="margin-left:6px">人，</span>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form :model="query">
                <el-form-item label="每人限报">
                  <el-input
                    style="width:80px"
                    onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                    maxlength="4"
                    v-model="query.projectMemberCount"
                  ></el-input>
                  <span style="margin-left:6px">项</span>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <template v-if="userInfo.project === 1 ||userInfo.project === 5 ||userInfo.project === 6">            
            <el-form-item label="男子双打限报几组">
                <el-input
                    style="width:80px"
                    onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                    maxlength="4"
                    v-model="query.doublesManCount"
                ></el-input>
                <span style="margin-left:6px">组（1组=2男）；</span>
            </el-form-item>
            <el-form-item label="女子双打限报几组">
                <el-input
                    style="width:80px"
                    onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                    maxlength="4"
                    v-model="query.doublesWomanCount"
                ></el-input>
                <span style="margin-left:6px">组（1组=2女）；</span>
            </el-form-item>
            <el-form-item label="男女混双限报几组">
                <el-input
                    style="width:80px"
                    onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
                    maxlength="4"
                    v-model="query.mixedCount"
                ></el-input>
                <span style="margin-left:6px">组（1组=1女1女）；</span>
            </el-form-item>
          </template>
          <el-form-item label="是否允许跨组报项目">
            <el-radio-group v-model="query.crossGroup">
              <el-radio :label="0">不允许</el-radio>
              <el-radio :label="1">允许</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <template v-else-if="userInfo.project === 4">
          <p class="swmming_regist_titles">参赛办法和报名规定</p>
          <el-form-item class="clear_float">
            <el-form inline :model="query" ref="inline_form" label-width="70px">
              <el-row style="margin-bottom:22px">
                <el-col :span="9">
                  <el-form-item label="领队:">
                    <el-select style="width:100px" v-model="query.leaderCount">
                      <el-option
                        v-for="(item,index) in swimmingNumberList"
                        :key="index"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>人；</span>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="工作人员:">
                    <el-select style="width:100px" v-model="query.personnelCount">
                      <el-option
                        v-for="(item,index) in swimmingNumberList"
                        :key="index"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>人；</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="9">
                  <el-form-item label="教练员:">
                    <el-select style="width:100px" v-model="query.coachCount">
                      <el-option
                        v-for="(item,index) in swimmingNumberList"
                        :key="index"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>人；</span>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="队医:">
                    <el-select style="width:100px" v-model="query.doctorCount">
                      <el-option
                        v-for="(item,index) in swimmingNumberList"
                        :key="index"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <span>人；</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-form :model="query" label-width="180px">
              <el-form-item label="每队每组限报男女运动员:" style="margin:20px 0;">
                <el-select style="width:100px" v-model="query.count">
                  <el-option
                    v-for="(item,index) in swimmingMoreNumberList"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <span>人；</span>
              </el-form-item>
              <el-form-item label="每队每组单一性别人数不超过:" style="margin:20px 0;">
                <el-select style="width:100px" v-model="query.genderCount">
                  <el-option
                    v-for="(item,index) in swimmingMoreNumberList"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <span>人；</span>
              </el-form-item>
              <el-form-item label="个人项目每人限报:">
                <el-select style="width:100px" v-model="query.projectMemberCount">
                  <el-option
                    v-for="(item,index) in swimmingMinNumberList"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <span>项（接力项目除外）</span>
              </el-form-item>
            </el-form>
          </el-form-item>
        </template>
        <el-form-item v-else label="人数限制" prop="count">
          <el-input-number
            style="width:195px"
            v-model="query.count"
            placeholder="请输入人数"
            controls-position="right"
            :min="min"
            :disabled="isFootBall"
          ></el-input-number>
          <!-- <el-input style="width:195px" v-model="query.count" placeholder="请输入人数"></el-input> -->
          <span style="margin-left:10px">人</span>
        </el-form-item>
        <el-form-item
          v-if="userInfo.project !== 4"
          style="margin-bottom:0"
          label="性别"
          prop="gender"
        >
          <el-radio-group v-model="query.gender" @change="handleChange">
            <el-radio :label="-1">全部</el-radio>
            <el-radio :disabled="isUpdateGender" :label="1">男</el-radio>
            <el-radio :disabled="isUpdateGender" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:90px;margin-right:40px" type="primary" @click="handleSubmit">确 定</el-button>
        <el-button style="width:90px;" @click="handleCancel">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 武术添加赛事弹窗 -->
    <el-dialog
      center
      :close-on-click-modal="false"
      :title="martial.title"
      :visible.sync="martial.isShow"
      width="800px"
      top="50px"
    >
      <div class="contents">
        <el-form ref="forms" :model="martialData" :rules="rules" label-width="100px">
          <el-form-item label="赛事名称" prop="name">
            <el-input style="width:540px" v-model="martialData.name" placeholder="请输入赛事名称"></el-input>
          </el-form-item>
          <el-form-item label="参赛组别" prop="groupId">
            <el-checkbox-group v-model="martialData.groupId">
              <el-checkbox label="1">甲组</el-checkbox>
              <el-checkbox label="2">乙组</el-checkbox>
              <el-checkbox label="4">丙组</el-checkbox>
              <el-checkbox label="3">丁组</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="报名时间" prop="time">
            <el-date-picker
              v-model="martialData.time"
              style="width:540px"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <p class="rule_title">参赛办法和报名规定：</p>
        <ul class="row_li">
          <li style="margin-right:100px">
            领队：
            <el-select style="width:100px" v-model="martialData.leaderCount">
              <el-option
                v-for="(item,index) in swimmingNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人</span>
          </li>
          <li>
            教练员：
            <el-select style="width:100px" v-model="martialData.coachCount">
              <el-option
                v-for="(item,index) in swimmingNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人</span>
          </li>
        </ul>
        <ul class="row_li">
          <li class="common_title">每队限报运动员：</li>
          <li style="margin:0 20px 0 0;">
            男生：
            <el-select style="width:100px" v-model="martialData.manCount">
              <el-option
                v-for="(item,index) in moreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人</span>
          </li>
          <li>
            女生：
            <el-select style="width:100px" v-model="martialData.womanCount">
              <el-option
                v-for="(item,index) in moreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人</span>
          </li>
        </ul>
        <ul class="row_li">
          <li class="common_title">品势团体每队限报：</li>
          <li style="margin:0 20px 0 0;">
            男生：
            <el-select style="width:100px" v-model="martialData.poomsaeManCount">
              <el-option
                v-for="(item,index) in moreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人</span>
          </li>
          <li>
            女生：
            <el-select style="width:100px" v-model="martialData.poomsaeWomanCount">
              <el-option
                v-for="(item,index) in moreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人</span>
          </li>
        </ul>
        <ul class="row_li">
          <li class="common_title" style="width:140px;margin-right:31px">每项每队限报运动员：</li>
          <li>
            <el-select style="width:100px" v-model="martialData.memberProjectCount">
              <el-option
                v-for="(item,index) in swimmingMoreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人</span>
          </li>
        </ul>
        <ul class="row_li">
          <li class="common_title" style="width:140px;margin-right:31px">每人限报项目：</li>
          <li>
            <el-select style="width:100px" v-model="martialData.projectMemberCount">
              <el-option
                v-for="(item,index) in swimmingMoreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人</span>
          </li>
        </ul>
        <ul class="row_li">
          <li>
            <el-radio-group v-model="martialData.includePoomsae">
              <el-radio style="margin-right:75px" :label="1">含品势团体</el-radio>
              <el-radio :label="0">不含品势团体</el-radio>
            </el-radio-group>
          </li>
        </ul>
        <p class="fill_in_control">
          <span>报名表填写控制</span>
          <span>（非必选项）</span>
          <span>提示：选择之后，用户可以输入项目名称报名。</span>
        </p>
        <ul class="row_li">
          <li>
            <el-checkbox-group v-model="martialData.checkList">
              <el-checkbox :label="1">其它拳术（单项）（备注项目）</el-checkbox>
              <el-checkbox :label="2">其它器械（单项）（备注项目）</el-checkbox>
            </el-checkbox-group>
          </li>
        </ul>
      </div>
      <footer>
        <el-button
          style="width:90px;margin-right:20px;border-color:#1E63B0;color:#1E63B0;"
          @click="martialSubmit"
        >确 定</el-button>
        <el-button
          style="width:90px;background:#1E63B0;border-color:#1E63B0;margin:0"
          type="primary"
          @click="handleCancel"
        >取 消</el-button>
      </footer>
    </el-dialog>
    <!-- 健美操赛事添加/修改弹窗 -->
    <el-dialog
      center
      :close-on-click-modal="false"
      :title="aerobics.title"
      :visible.sync="aerobics.isShow"
      width="910px"
      top="50px"
    >
      <div class="contents competition_contents">
        <el-form ref="aerobicsForm" :model="aerobicsData" :rules="rules" label-width="100px">
          <el-form-item label="赛事名称" prop="name">
            <el-input style="width:540px" v-model="aerobicsData.name" placeholder="请输入赛事名称"></el-input>
          </el-form-item>
          <el-form-item label="参赛组别" prop="groupId">
            <el-checkbox-group v-model="aerobicsData.groupId">
              <el-checkbox label="1">甲组</el-checkbox>
              <el-checkbox label="2">乙组</el-checkbox>
              <el-checkbox label="4">丙组</el-checkbox>
              <el-checkbox label="3">丁组</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="报名时间" prop="time">
            <el-date-picker
              v-model="aerobicsData.time"
              style="width:540px"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <p class="rule_title must">竞赛项目：</p>
        <ul class="row_li competition_box">
          <li>
            <el-checkbox
              :indeterminate="aerobics.indeterminate"
              v-model="aerobics.checkAll"
              @change="$event=>handleCheckAllCompeteChange('aerobicsSportsStr','indeterminate',$event)"
            >竞技健美操项目</el-checkbox>
          </li>
          <li class="project">
            <el-checkbox-group
              v-model="aerobicsData.aerobicsSportsStr"
              @change="$event=>handleCheckedCompeteChange('aerobicsSportsStr',$event,'indeterminate','checkAll')"
            >
              <el-checkbox
                v-for="(val,num) in aerobics.aerobicsSportsStr"
                :label="val"
                :key="num + '-' + val"
              ></el-checkbox>
            </el-checkbox-group>
          </li>
          <li>
            <el-checkbox
              :indeterminate="aerobics.wholePeopleIndeterminate"
              v-model="aerobics.wholePeopleCheckAll"
              @change="$event=>handleCheckAllCompeteChange('aerobicsPeopleStr','wholePeopleIndeterminate',$event)"
            >全民健身操项目</el-checkbox>
          </li>
          <li class="project">
            <el-checkbox-group
              v-model="aerobicsData.aerobicsPeopleStr"
              @change="$event=>handleCheckedCompeteChange('aerobicsPeopleStr',$event,'wholePeopleIndeterminate','wholePeopleCheckAll')"
            >
              <el-checkbox
                v-for="(item,index) in aerobics.aerobicsPeopleStr"
                :label="item"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
          </li>
        </ul>
        <p class="rule_title">参赛办法和报名规定：</p>
        <ul class="row_li">
          <li>
            领队：
            <el-select style="width:100px" v-model="aerobicsData.leaderCount">
              <el-option
                v-for="(item,index) in swimmingMoreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人；</span>
          </li>
          <li>
            教练员：
            <el-select style="width:100px" v-model="aerobicsData.coachCount">
              <el-option
                v-for="(item,index) in swimmingMoreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人；</span>
          </li>
          <li>
            每组每队参赛总人数上限：
            <el-select style="width:100px" v-model="aerobicsData.count">
              <el-option
                v-for="(item,index) in swimmingMoreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人；</span>
          </li>
        </ul>
        <ul class="row_li">
          <li>
            竞技健美操项目每队限报：
            <el-select style="width:100px" v-model="aerobicsData.aerobicsSportsCount">
              <el-option v-for="(item,index) in 6" :key="index" :value="item" :label="item"></el-option>
            </el-select>
            <span>项，</span>
          </li>
          <li>
            男子单人操每队限报：
            <el-select style="width:100px" v-model="aerobicsData.manCount">
              <el-option
                v-for="(item,index) in swimmingMoreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人，</span>
          </li>
          <li>
            女子单人操每队限报：
            <el-select style="width:100px" v-model="aerobicsData.womanCount">
              <el-option
                v-for="(item,index) in swimmingMoreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
            <span>人；</span>
          </li>
        </ul>
        <ul class="row_li">
          <li>
            全民健身操项目每队限报：
            <el-select style="width:100px" v-model="aerobicsData.aerobicsPeopleCount">
              <el-option v-for="(item,index) in 3" :key="index" :value="item" :label="item"></el-option>
            </el-select>
            <span>项；</span>
          </li>
          <li>替补运动员人数上限：
              <el-select style="width:100px" 
                clearable
                placeholder="选择人数" v-model="aerobicsData.alternateCount">
              <el-option
                v-for="(item,index) in swimmingMoreNumberList"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
              <span>人。</span>
          </li>
        </ul>
      </div>
      <footer>
        <el-button
          style="width:90px;margin-right:20px;border-color:#1E63B0;color:#1E63B0;"
          @click="aerobicsSubmit"
        >确 定</el-button>
        <el-button
          style="width:90px;background:#1E63B0;border-color:#1E63B0;margin:0"
          type="primary"
          @click="aerobicsCancel"
        >取 消</el-button>
      </footer>
    </el-dialog>
    <el-dialog
      center
      :close-on-click-modal="false"
      title="删除"
      width="600px"
      :visible.sync="deleteModal"
    >
      <p style="font-size:18px;text-align:center;padding:20px">删除之后数据将不可恢复，是否继续？</p>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:90px;margin-right:40px" type="primary" @click="handleDelete">确 定</el-button>
        <el-button style="width:90px;" @click="deleteModal = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getMatchList,
  updateMatch,
  addMatch,
  deleteMatch
} from "@/api/sports-management.js";
import registerData from "@/assets/json/register.json";
import { table, message, page, dialog } from "@/common/js/mixins.js";
import { method } from "@/utils/utils";
import { getSession } from "@/utils/storage.js";
export default {
  mixins: [table, message, page, dialog],
  data() {
    return {
      min: 1, //由于修改只能往上增加，根据新增/修改 更替最小值
      operationId: "",
      isDisabled: false,
      userInfo: JSON.parse(getSession("userInfo")),
      martial: {
        // 武术赛事添加弹窗
        title: "",
        isShow: false
      },
      aerobics: {
        // 健美操赛事添加弹窗
        title: "",
        isShow: false,
        indeterminate: false, // 竞技健美操项目不确定状态
        checkAll: false, // 竞技健美操项目全选
        aerobicsSportsStr: [
          "男子单人操",
          "女子单人操",
          "混合双人操",
          "三人操",
          "5人自编有氧舞蹈",
          "5人自编有氧踏板操"
        ],
        wholePeopleIndeterminate: false,
        wholePeopleCheckAll: false,
        aerobicsPeopleStr: ["5人自编器械操", "5人自编街舞", "5人自编徒手操"]
      },
      martialData: {
        name: "",
        groupId: [],
        time: [],
        gender: "-1",
        count: 0,
        startTime: "",
        endTime: "",
        leaderCount: 1,
        coachCount: 1,
        womanCount: 14,
        manCount: 14,
        poomsaeManCount: 14,
        poomsaeWomanCount: 14,
        memberProjectCount: 2,
        projectMemberCount: 2,
        includePoomsae: 1,
        checkList: []
      },
      aerobicsData: {
        name: "",
        groupId: [],
        time: [],
        startTime: "",
        endTime: "",
        aerobicsSportsStr: [],
        aerobicsPeopleStr: [],
        leaderCount: 1,
        coachCount: 1,
        aerobicsSportsCount: 1,
        aerobicsPeopleCount: 1,
        count: 14,
        manCount: 14,
        womanCount: 14,
        gender:-1,
        alternateCount:""
      },
      query: {
        count: 0,
        crossGroup: 0,
        count: 1, // 限制人数
        memberProjectCount: "",
        genderCount: "", // 单一性别人数限制
        startTime: "",
        endTime: "",
        groupId: "",
        time: [],
        gender: -1,
        name: "",
        projectMemberCount: "", // 每人限报项目限制
        doublesManCount:"", // 小球男双人数上限
        doublesWomanCount:"", // 小球女双人数上限
        mixedCount:"",// 小球混双人数上限
        leaderCount: "", // 领队人数限制
        coachCount: "", // 教练人数限制
        doctorCount: "", // 医生人数限制
        personnelCount: "" // 工作人员人数限制
      },
      rules: {
        name: [
          { required: true, message: "赛事名称不能为空", trigger: "blur" }
        ],
        groupId: [
          {
            required: true,
            message: "参赛组别不能为空",
            trigger: "change"
          }
        ],
        time: [
          { required: true, message: "报名时间不能为空", trigger: "change" }
        ],
        count: [{ required: true, message: "人数不能为空", trigger: "blur" }],
        gender: [{ required: true }]
      }
    };
  },
  computed: {
    //
    formatGroup() {
      return data => {
        let arr = [];
        data.split(",").filter(item => {
          if (item == 1) arr.push("甲组");
          else if (item == 2) arr.push("乙组");
          else if (item == 3) arr.push("丙组");
          else arr.push("丁组");
        });

        return arr.join(",");
      };
    },
    formatGroups() {
      return data => {
        let arr = [];
        data.split(",").filter(item => {
          if (item == 1) arr.push("甲组");
          else if (item == 2) arr.push("乙组");
          else if (item == 3) arr.push("丁组");
          else arr.push("丙组");
        });
        return arr.join(",");
      };
    },
    // 网球、羽毛球、乒乓球、田径公用
    isOtherBall() {
      return (
        this.userInfo.project === 9 ||
        this.userInfo.project === 1 ||
        this.userInfo.project === 5 ||
        this.userInfo.project === 6
      );
    },
    // 如果当前赛事为足球赛事，则固定参赛人数,并禁用输入
    isFootBall() {
      let project = JSON.parse(getSession("userInfo")).project;
      if (project === 7) {
        this.query.count = 25;
        return true;
      }
      return false;
    },
    // 获取注册组别
    registGroup() {
      return [
        {
          label: "甲组（普通本科）",
          value: "1"
        },
        {
          label: "乙组（高职高专）",
          value: "2"
        },
        {
          label: "丁组（高水平）",
          value: "3"
        },
        {
          label: "丙组（体育院系）",
          value: "4"
        }
      ];
    },
    isUpdateGender() {
      if (this.title === "修改赛事") {
        if (this.query.gender === -1 && !this.isDisabled) return true;
        else return false;
      }
    },
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    },
    formatGender() {
      return data => {
        return data === -1 ? "全部" : data === 1 ? "男" : "女";
      };
    },
    // 游泳赛事人数列表
    swimmingNumberList() {
      let list = [];
      for (let i = 1; i <= 20; i++) {
        list.push(i);
      }
      return list;
    },
    // 100人选择列表（不包含0）
    swimmingMoreNumberList() {
      let list = [];
      for (let i = 1; i <= 100; i++) {
        list.push(i);
      }
      return list;
    },
    // 100人选择列表（包含0）
    moreNumberList() {
      let list = [];
      for (let i = 0; i <= 100; i++) {
        list.push(i);
      }
      return list;
    },
    swimmingMinNumberList() {
      let list = [];
      for (let i = 1; i <= 10; i++) {
        list.push(i);
      }
      return list;
    }
  },
  methods: {
    // 健美操/竞技项目全选
    handleCheckAllCompeteChange(modal, indeterminate, val) {
      this.aerobics[indeterminate] = false;
      if (val) {
        this.$set(this["aerobicsData"], [modal], [...this["aerobics"][modal]]);
      } else {
        this.$set(this["aerobicsData"], [modal], []);
      }
    },
    // 健美操/竞技项目单个选择
    handleCheckedCompeteChange(modal, val, indeterminate, checkAll) {
      this.selectProject(modal, indeterminate, checkAll);
    },
    // 健美操-竞技项目/全民项目单个选择
    selectProject(modal, indeterminate, checkAll) {
      const i = this["aerobics"][modal].length;
      const len = this["aerobicsData"][modal].length;
      if (len === i) {
        Object.assign(this["aerobics"], {
          [checkAll]: true,
          [indeterminate]: false
        });
      } else {
        Object.assign(this["aerobics"], {
          [checkAll]: false,
          [indeterminate]: true
        });
      }
    },
    // 足球赛事创建选择组别，如果组别为混合组，则运动员性别固定为全部
    selectGroup(e) {
      if (e === "5") this.$set(this.query, "gender", -1);
    },
    //
    handleChange(value) {
      if (this.title === "修改赛事") {
        this.isDisabled = true;
      }
    },
    // 打开删除弹窗
    deletes(id) {
      this.operationId = id;
      this.openDeleteDialog();
    },
    // 确认删除
    handleDelete() {
      deleteMatch({ id: this.operationId })
        .then(res => {
          this.openSuccess("删除成功！");
          this.closeDeleteDialog();
          this.getList();
        })
        .catch(err => {});
    },
    // 获取列表
    getList() {
      getMatchList({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      })
        .then(res => {
          this.total = res.total;
          res.list.filter(item => {
            item.startTime = method.timeFormat(item.startTime, null, true);
            item.endTime = method.timeFormat(item.endTime, null, true);
          });
          this.tableData = res.list;
        })
        .catch(err => {});
    },
    // 监听弹窗关闭事件
    closeModal() {
      this.$refs.form.resetFields();
      Object.assign(this.query, {
        crossGroup: 0,
        memberProjectCount: "",
        genderCount: "",
        projectMemberCount: "",
        doublesManCount:"",
        doublesWomanCount:"",
        mixedCount:"",
      });
    },
    // 武术赛事新增/修改
    martialSubmit() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          Object.assign(this.martialData, {
            startTime: this.martialData.time[0],
            endTime: this.martialData.time[1]
          });
          if (this.martial.title === "添加赛事") {
            addMatch({
              ...this.martialData,
              groupId: this.martialData.groupId.sort().join(","),
              otherBoxing: this.martialData.checkList.includes(1) ? 1 : 0,
              otherApparatus: this.martialData.checkList.includes(2) ? 1 : 0
            })
              .then(res => {
                this.openSuccess("添加成功！");
                this.martial.isShow = false;
                this.pageNo = 1;
                this.getList();
              })
              .catch(err => {});
          } else {
            updateMatch({
              ...this.martialData,
              groupId: this.martialData.groupId.sort().join(","),
              otherBoxing: this.martialData.checkList.includes(1) ? 1 : 0,
              otherApparatus: this.martialData.checkList.includes(2) ? 1 : 0,
              id: this.operationId
            })
              .then(res => {
                this.openSuccess("修改成功！");
                this.martial.isShow = false;
                this.getList();
              })
              .catch(err => {});
          }
        }
      });
    },
    // 弹窗新增/修改
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          Object.assign(this.query, {
            startTime: this.query.time[0],
            endTime: this.query.time[1]
          });
          if (this.title === "新增赛事") {
            addMatch({
              ...this.query,
              groupId:
                this.isOtherBall || this.userInfo.project === 4
                  ? this.query.groupId.sort().join(",")
                  : this.query.groupId
            })
              .then(res => {
                this.openSuccess("添加成功！");
                this.closeDialog();
                this.pageNo = 1;
                this.getList();
              })
              .catch(err => {});
          } else {
            updateMatch({
              ...this.query,
              groupId:
                this.isOtherBall || this.userInfo.project === 4
                  ? this.query.groupId.sort().join(",")
                  : this.query.groupId,
              id: this.operationId
            })
              .then(res => {
                this.openSuccess("修改成功！");
                this.closeDialog();
                this.getList();
              })
              .catch(err => {});
          }
        }
      });
    },
    // 健美操弹窗取消
    aerobicsCancel() {
      this.$refs.aerobicsForm.resetFields();
      Object.assign(this.aerobics, {
        isShow: false
      });
    },
    // 健美操赛事新增/修改
    aerobicsSubmit() {
      this.$refs.aerobicsForm.validate(valid => {
        if (valid) {
          Object.assign(this.aerobicsData, {
            startTime: this.aerobicsData.time[0],
            endTime: this.aerobicsData.time[1]
          });
          const { aerobicsSportsStr, aerobicsPeopleStr } = this.aerobicsData;
          // 判断竞技健美操项目是否选择
          if (aerobicsSportsStr.length == 0) {
            return this.openWarn("竞技健美操项目不能为空！");
          }
          if (aerobicsPeopleStr.length == 0) {
            return this.openWarn("全民健身操项目不能为空！");
          }
          // 项目排序
          let aerobicsSports = [];
          let aerobicsPeople = [];
          this.aerobics.aerobicsSportsStr.filter(item=>{
            if(aerobicsSportsStr.includes(item)) {
              aerobicsSports.push(item);
            }
          })          
          this.aerobics.aerobicsPeopleStr.filter(item=>{
            if(aerobicsPeopleStr.includes(item)) {
              aerobicsPeople.push(item);
            }
          })
          if (this.aerobics.title === "添加赛事") {
            addMatch({
              ...this.aerobicsData,
              groupId: this.aerobicsData.groupId.sort().join(","),
              aerobicsSportsStr: aerobicsSports.join(","),
              aerobicsPeopleStr: aerobicsPeople.join(",")
            })
              .then(res => {
                this.openSuccess("添加成功！");
                this.aerobics.isShow = false;
                this.pageNo = 1;
                this.getList();
              })
              .catch(err => {});
          } else {
            updateMatch({
              ...this.aerobicsData,
              groupId: this.aerobicsData.groupId.sort().join(","),
              aerobicsSportsStr: aerobicsSports.join(","),
              aerobicsPeopleStr: aerobicsPeople.join(","),
              id: this.operationId
            })
              .then(res => {
                this.openSuccess("修改成功！");
                this.aerobics.isShow = false;
                this.getList();
              })
              .catch(err => {});
          }
        }
      });
    },
    // 弹窗取消
    handleCancel() {
      if (this.userInfo.project == 2) {
        this.$refs.forms.resetFields();
        Object.assign(this.martial, {
          isShow: false
        });
      }
      this.$refs.form.resetFields();
      this.closeDialog();
      Object.assign(this.query, {
        crossGroup: 0,
        memberProjectCount: "",
        genderCount: "",
        projectMemberCount: ""
      });
    },
    // 打开新增弹窗
    addMatchModal() {
      if (this.userInfo.project == 2) {
        Object.assign(this.martial, {
          isShow: true,
          title: "添加赛事"
        });
        this.$nextTick(() => {
          if (this.$refs.forms) this.$refs.forms.resetFields();
          Object.assign(this.martialData, {
            name: "",
            groupId: [],
            time: [],
            gender: "-1",
            count: 0,
            startTime: "",
            endTime: "",
            leaderCount: 1,
            coachCount: 1,
            womanCount: 14,
            manCount: 14,
            poomsaeManCount: 14,
            poomsaeWomanCount: 14,
            memberProjectCount: 2,
            projectMemberCount: 2,
            includePoomsae: 1,
            checkList: []
          });
        });
        return;
      } else if (this.userInfo.project == 3) {
        Object.assign(this.aerobics, this.$options.data().aerobics);
        Object.assign(this.aerobicsData, this.$options.data().aerobicsData);
        if (this.$refs.aerobicsForm) this.$refs.aerobicsForm.resetFields();
        this.$nextTick(() => {
          Object.assign(this.aerobics, {
            isShow: true,
            title: "添加赛事"
          });
        });
        return;
      }
      this.openDialog("新增赛事");
      this.$nextTick(() => {
        this.min = 1;
        if (this.$refs.form) this.$refs.form.resetFields();
        Object.assign(this.query, {
          crossGroup: 0,
          memberProjectCount: "",
          genderCount: "",
          projectMemberCount: "",
          doublesManCount:"",
          doublesWomanCount:"",
          mixedCount:"",
          leaderCount: "", 
          coachCount: "", 
          doctorCount: "", 
          personnelCount: "",
          count:this.userInfo.project === 4?14:this.userInfo.project === 7?25:''
        });
      });
    },
    // 打开修改弹窗
    updates(data) {
      this.operationId = data.id;
      if (this.userInfo.project == 2) {
        Object.assign(this.martial, {
          isShow: true,
          title: "修改赛事"
        });
        this.$nextTick(() => {
          for (let item in data) {
            if (this.martialData.hasOwnProperty(item)) {
              this.$set(this.martialData, item, data[item]);
            }
          }
          Object.assign(this.martialData, {
            time: [this.martialData.startTime, this.martialData.endTime],
            groupId: data.groupId.split(","),
            checkList:
              data.otherBoxing && data.otherApparatus
                ? [1, 2]
                : data.otherBoxing
                ? [1]
                : data.otherApparatus
                ? [2]
                : []
          });
        });
        return;
      } else if (this.userInfo.project == 3) {
        Object.assign(this.aerobics, {
          isShow: true,
          title: "修改赛事"
        });
        this.$nextTick(() => {
          for (let item in data) {
            if (this.aerobicsData.hasOwnProperty(item)) {
              if(item == 'aerobicsPeopleStr' || item == 'aerobicsSportsStr') {
                this.$set(this.aerobicsData, item, data[item].split(","));
              }
              else this.$set(this.aerobicsData, item, data[item]);
            }
          }
          Object.assign(this.aerobicsData, {
            time: [this.aerobicsData.startTime, this.aerobicsData.endTime],
            groupId: data.groupId.split(","),
          });
          Object.assign(this.aerobics,{
            indeterminate:this.aerobicsData.aerobicsSportsStr.length == this.aerobics.aerobicsSportsStr.length?false:true,
            checkAll:this.aerobicsData.aerobicsSportsStr.length == this.aerobics.aerobicsSportsStr.length?true:false,
            wholePeopleIndeterminate: this.aerobicsData.aerobicsPeopleStr.length == this.aerobics.aerobicsPeopleStr.length?false:true,
            wholePeopleCheckAll: this.aerobicsData.aerobicsPeopleStr.length == this.aerobics.aerobicsPeopleStr.length?true:false,
          })
        });
        return;
      }
      this.isDisabled = false;
      this.openDialog("修改赛事");
      this.$nextTick(() => {
        this.min = data.count;
        for (let item in data) {
          if (this.query.hasOwnProperty(item)) {
            this.$set(this.query, item, data[item]);
          }
        }
        if (this.isOtherBall || this.userInfo.project === 4) {
          this.$set(this.query, "groupId", data.groupId.split(","));
        }
        this.$set(this.query, "time", [
          this.query.startTime,
          this.query.endTime
        ]);
      });
    }
  },
  mounted() {
    this.getList();
    if (this.isOtherBall || this.userInfo.project === 4) {
      this.query.groupId = [];
      if (this.userInfo.project === 4) this.query.count = 14;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
<style lang="less">
.add_match {
  .el-form {
    .swmming_regist_titles {
      margin: 0 0 20px 70px;
      padding: 10px 0 0 0;
      color: #606266;
    }
    .group_id .el-form-item__error {
      top: 85%;
    }
  }
  .el-form .clear_float > .el-form-item__content {
    margin-left: 100px !important;

    .el-form-item__label {
      font-size: 12px;
      color: #333;
    }
    .el-form-item__content {
      > span {
        font-size: 12px;
        margin-left: 6px;
        color: #333;
      }
    }
  }
}
.rule_title {
  color: #606266;
  margin: 0 0 0 31px;
}
.must {
  margin: 0 0 0 21px;
  &::before {
    content: "*";
    font-size: 14px;
    color: #f56c6c;
    margin-right: 4px;
  }
}
.row_li {
  display: flex;
  align-items: center;
  margin: 20px 0 0 60px;
  > li {
    font-size: 12px;
    > span {
      margin-left: 10px;
    }
    &.common_title {
      width: 130px;
      font-size: 14px;
    }
  }
}
.competition_box {
  display: block;
  > li {
    margin-bottom: 15px;
  }
  > .project {
    margin-left: 24px;
  }
}
.fill_in_control {
  display: flex;
  align-items: center;
  margin: 20px 0 0 31px;
  > span:first-of-type {
    color: #333;
  }
  > span:nth-of-type(2) {
    color: #999;
    width: 84px;
    margin: 0 4px 0 16px;
  }
  > span:last-of-type {
    color: #fd6666;
  }
}
.contents {
  margin: 0 0 0 38px;
}
.competition_contents {
  margin: 0;
}
footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0 10px 0;
}
</style>